import {OptInAccordionTitleMrGreenBox} from "./opt-in-accordion-title.mrgreen.box";

export const OptInAccordionTitleMrGreenCisBox = OptInAccordionTitleMrGreenBox;